import { getPage, getFrontpage } from 'services/api/Shop';
import home1 from '../../assets/home_1.png';
import home2 from '../../assets/home_2.png';
import home3 from '../../assets/home_3.png';
import './Home.scss';
import React, { useEffect, useState } from "react";
import { getOfflineContent, saveOfflineContent } from '../../utils/offlineContent';

const Home = () => {
  const [frontLeft, setFrontLeft] = useState(""); 
  const [frontCenter, setFrontCenter] = useState(""); 
  const [frontRight, setFrontRight] = useState(""); 
  const [isOfflineFallback, setIsOfflineFallback] = useState(false);


  useEffect(() => {
    const loadHomePage = async () => {
      try {
        await getPage(132);
        const token = sessionStorage.getItem('token');
        const data = await getFrontpage(token);
        const nextContent = {
          frontLeft: data?.content?.sections?.front_left?.articles?.[0]?.content || "",
          frontCenter: data?.content?.sections?.front_center?.articles?.[0]?.content || "",
          frontRight: data?.content?.sections?.front_right?.articles?.[0]?.content || "",
        };

        if (!nextContent.frontLeft && !nextContent.frontCenter && !nextContent.frontRight) {
          throw new Error('Frontpage content unavailable');
        }

        setFrontLeft(nextContent.frontLeft);
        setFrontCenter(nextContent.frontCenter);
        setFrontRight(nextContent.frontRight);
        setIsOfflineFallback(false);
        saveOfflineContent('home-frontpage', nextContent);
      } catch (_error) {
        const cachedContent = getOfflineContent('home-frontpage');

        if (cachedContent?.value) {
          setFrontLeft(cachedContent.value.frontLeft || "");
          setFrontCenter(cachedContent.value.frontCenter || "");
          setFrontRight(cachedContent.value.frontRight || "");
          setIsOfflineFallback(true);
        }
      }
    };

    loadHomePage();
  }, []);

  return (
    <div className="container">
      <h1>Votre marché aux fleurs en ligne.</h1>
      {isOfflineFallback && (
        <p className="offline-content-notice">
          Vous consultez la dernière version enregistrée de cette page.
        </p>
      )}
      <div className="row home-row">
        <div className="col-md-4 home-col">
          <div className="home-image">
            <img alt="trois bulles de profil" src={home1} />
          </div>
          <h2><a href="/new-account">Créez votre profil</a></h2>
          <p>Remplissez le formulaire d’inscription, nous validons votre inscription pour vous donner accès à toutes nos offres.</p>
        </div>
        <div className="col-md-4 home-col">
          <div className="home-image">
            <img alt="smartphone et femme poussant un chariot" src={home2} />
          </div>
          <h2>Choisissez vos fleurs en ligne</h2>
          <p>Choisissez parmi notre large choix de fleurs fraiches et chaque semaine nous vous proposons des colis avec nos promotions du moment.</p>
        </div>
        <div className="col-md-4 home-col">
          <div className="home-image">
            <img alt="carte de la france" src={home3} />
          </div>
          <h2>Livraisons partout en France</h2>
          <p>Nous Livrons partout en France en 48-72h selon l’heure à laquelle vous passez commande. Un suivi complet sera disponible dans votre application</p>
        </div>
      </div>
      <div className="row home-row">
        <div className="col-md-4 home-col col-left">
          <div dangerouslySetInnerHTML={{__html: frontLeft}} />
        </div>
        <div className="col-md-4 home-col col-center">
          <div dangerouslySetInnerHTML={{__html: frontCenter}} />
        </div>
        <div className="col-md-4 home-col col-right">
          <div dangerouslySetInnerHTML={{__html: frontRight}} />
        </div>
      </div>
    </div>
  )
}

export default Home;
